// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditIndexerModalContent-deleteButton-gyzhH Button-button-paJ9a Link-link-RInnp"};